import React from 'react';
import styles from '../RateView.module.css';
import FilterLabel from './FilterLabel';
import {dateInputFormatToRegularFormat, dateRegularFormatToInputFormat} from '../../../util/tools';

class FilterDateDiapason extends React.Component {

	constructor(props) {
		super(props);
		let filter = props.filter;
		this.filterValue = {
			fromAsString: dateInputFormatToRegularFormat(filter.initialValue), // yyyy-mm-dd
			toAsString: dateInputFormatToRegularFormat(filter.initialValue2),
			fromAsNumber: filter.initialValueNumber, // Date as milliseconds
			toAsNumber: filter.initialValueNumber2
		};
		this.state = {
			dirtyCount: 0, 
			fromValue: dateRegularFormatToInputFormat(this.filterValue.fromAsString), 
			toValue: dateRegularFormatToInputFormat(this.filterValue.toAsString) 
		};
		if( this.filterValue.fromAsNumber || this.filterValue.toAsNumber )
			this.updateQuery();
	}
	componentDidMount() {
		let rateView = this.props.rateView;
		rateView.registerFilter( this );
	}
	componentWillUnmount() {
		let rateView = this.props.rateView;
		rateView.unregisterFilter( this );
	}

	clearFilter() {
		this.props.rateView.clearQueryFilter( this.props.filter.predicateId )
		this.filterValue = {
			fromAsString: '', 
			toAsString: '',
			fromAsNumber: '', 
			toAsNumber: ''
		}
		this.setState({
			dirtyCount: this.state.dirtyCount+1,
			fromValue: '', 
			toValue: '' 
		});
	}
	handleValueChange = (e) => {
		this.props.rateView.clearData();
		const {name, value, valueAsNumber} = e.target;
		let valueNumber = isNaN( valueAsNumber ) ? null : valueAsNumber;
		
		if( name == 'dateFrom' ) {
			this.filterValue.fromAsString = dateInputFormatToRegularFormat( value ); //value;
			this.filterValue.fromAsNumber = valueNumber;
		} else if( name == 'dateTo' ) {
			this.filterValue.toAsString = dateInputFormatToRegularFormat( value ); //value;
			this.filterValue.toAsNumber = valueNumber;
		}

		if( this.filterValue.fromAsNumber == null && this.filterValue.toAsNumber == null ) {
			this.props.rateView.clearQueryFilter( this.props.filter.predicateId )
			return;
		}
		
		this.updateQuery();

		if( name == 'dateFrom' ) {
			this.setState({fromValue: value});
		} else if( name == 'dateTo' ) {
			this.setState({toValue: value});
		}
	}
	updateQuery = () => {
		let q = this.props.rateView.query;
		let indexFilter = -1;
		for(let i=0; i < q.listPredicate.length; i++) {
			if( q.listPredicate[i].predicateId == this.props.filter.predicateId ) {
				indexFilter = i;
				break;
			}
		}
		if( indexFilter < 0 ) {
			q.listPredicate.push( {
				predicateId: this.props.filter.predicateId,
				conditionId: this.props.filter.conditionId,
				valueFrom: this.filterValue.fromAsNumber,
				fromAsString: this.filterValue.fromAsString,
				valueTo: this.filterValue.toAsNumber,
				toAsString: this.filterValue.toAsString,
			} );
		} else {
			q.listPredicate[indexFilter].valueFrom = this.filterValue.fromAsNumber;
			q.listPredicate[indexFilter].fromAsString = this.filterValue.fromAsString;
			q.listPredicate[indexFilter].valueTo = this.filterValue.toAsNumber;
			q.listPredicate[indexFilter].toAsString = this.filterValue.toAsString;
		}
	}

	fetchProfile = () => {
		if( this.filterValue.fromAsNumber || this.filterValue.toAsNumber )
			return {
				filterId: this.props.filter.predicateId, 
				fromAsString: this.filterValue.fromAsString,
				toAsString: this.filterValue.toAsString,
				fromAsNumber: this.filterValue.fromAsNumber,
				toAsNumber: this.filterValue.toAsNumber,
			};
		else
			return null;
	}
	applyProfile = (profile) => {
		this.filterValue.fromAsString = profile.fromAsString;
		this.filterValue.fromAsNumber = profile.fromAsNumber;
		this.filterValue.toAsString = profile.toAsString;
		this.filterValue.toAsNumber = profile.toAsNumber;
		this.updateQuery();
		this.setState({
			dirtyCount: this.state.dirtyCount+1,
			fromValue: dateRegularFormatToInputFormat(this.filterValue.fromAsString), 
			toValue: dateRegularFormatToInputFormat(this.filterValue.toAsString) 
		});
	}
	
	render() {
		let filter = this.props.filter;
		return (
			<div className={styles.divFilter}>
				<FilterLabel title={filter.title} tooltip={filter.tooltip} />
				<div className={styles.divFilterInput}>
					<input type='date' name='dateFrom' value={this.state.fromValue} 
						onChange={this.handleValueChange}
					/>
					&nbsp;-&nbsp;
					<input type='date' name='dateTo' value={this.state.toValue} 
						onChange={this.handleValueChange}
					/>
				</div>
			</div>
		);
	}	
}

export default FilterDateDiapason;